import { Injectable } from '@angular/core';

@Injectable()
export class BreadcrumbService {

  breadcrumbArray = [];
  category: string;
  sharedUserName: string;
  userInfo: any;

  constructor() { }

  // get the current zone for Dynamic Form
  public getCurrentZone(sectionTitle, myUser) {
    this.category = this.getFriendlyCategoryText(sectionTitle, true, myUser);
    return this.category;
  }

  getFriendlyCategoryText(unfriendly: string, includeClient: boolean, myUser) {
    let retVal = "";
    if (unfriendly.toLowerCase().includes("asset")) {
      retVal = "Assets";
    }
    if (unfriendly.toLowerCase().includes("debt")) {
      retVal = "Debts";
    }
    if (unfriendly.toLowerCase().includes("daily")) {
      retVal = "Daily Life";
    }
    if (unfriendly.toLowerCase().includes("digital")) {
      retVal = "Digital Life";
    }
    if (unfriendly.toLowerCase().includes("wish")) {
      retVal = "Wishes";
    }
    if (myUser.delegate && myUser.delegate && includeClient) {
      retVal = retVal + " - " + myUser.delegate.clientFirstName + " " + myUser.delegate.clientLastName;
    }
    return retVal;
  }
}